import { component as defineComponent } from 'flightjs';

import withChildComponents from 'flight-with-child-components';
import WatchButtonUI from 'browse/ui/watch-button';
import ArchiveButtonUI from 'browse/ui/archive-button';
import withSpinner from 'app/mixins/with-loading-spinner';
import ListingsPagination from 'browse/ui/listings-pagination';
import '@99designs/asimov/tooltip';
import 'app/modules/datetime';

function contests() {
    this.childTeardownEvent = 'dataContestsLoaded';

    this.attributes({
        listings: '[data-listings]',
        watchButton: '[data-watch-button]',
        archiveButton: '[data-archive-button]',
        dateTimeItem: '.gmttime',
        paginator: '[data-paginator]',
    });

    this.showContests = function(e, data) {
        // BEFORE
        $('.tooltip').remove();
        this.select('listings')
            .find('[data-tooltip]')
            .remove();

        this.$node.html(data);

        // AFTER
        this.initializeListings();
    };

    this.tooltips = function() {
        $(this.select('listings'))
            .find('[data-tooltip]')
            .tooltip();
    };

    this.initializeListings = function() {
        this.attachChild(WatchButtonUI, this.select('watchButton'));
        this.attachChild(ArchiveButtonUI, this.select('archiveButton'));
        this.attachChild(ListingsPagination, this.select('paginator'));
        this.select('dateTimeItem').dateTime();
        this.tooltips();
    };

    this.after('initialize', function() {
        this.initializeListings();
        this.initializeLoadingSpinner(this.$node);
        this.on(document, this.childTeardownEvent, this.showContests);
    });
}

export default defineComponent(contests, withChildComponents, withSpinner);



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/listings-pane.js